const ITEMS = ["Estratégia", "Marketing", "Vendas", "Crescimento", "Método", "Resultados"];

export const Marquee = ({ tone = "lime" }) => {
  const row = [...ITEMS, ...ITEMS];
  const bg = tone === "lime" ? "bg-[#CCFF00] text-[#060B19]" : "bg-[#060B19] text-white";
  return (
    <div className={`relative overflow-hidden py-6 sm:py-8 ${bg}`} data-testid={`marquee-${tone}`} aria-hidden="true">
      <div className="animate-marquee flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center">
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="font-display flex items-center whitespace-nowrap px-6 text-4xl font-extrabold tracking-[-0.03em] sm:text-6xl lg:text-7xl">
                <span className={i % 2 ? "italic font-medium" : ""}>{w}</span>
                <svg viewBox="0 0 24 24" className="ml-12 h-6 w-6 sm:h-8 sm:w-8"><path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" fill="currentColor" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
